import { createBranch, updateBranch as editBranch, getBranches, getRegions } from '../utils/apiService';

export const CREATE_BRANCH = 'branch/CREATE_BRANCH';
export const CREATE_BRANCH_PENDING = 'branch/CREATE_BRANCH_PENDING';
export const CREATE_BRANCH_FULFILLED = 'branch/CREATE_BRANCH_FULFILLED';
export const CREATE_BRANCH_REJECTED = 'branch/CREATE_BRANCH_REJECTED';

export const LIST_BRANCHES = 'branch/LIST_BRANCHES';
export const LIST_BRANCHES_PENDING = 'branch/LIST_BRANCHES_PENDING';
export const LIST_BRANCHES_REJECTED = 'branch/LIST_BRANCHES_REJECTED';
export const LIST_BRANCHES_FULFILLED = 'branch/LIST_BRANCHES_FULFILLED';

export const LIST_REGIONS = 'branch/LIST_REGIONS';
export const LIST_REGIONS_PENDING = 'branch/LIST_REGIONS_PENDING';
export const LIST_REGIONS_REJECTED = 'branch/LIST_REGIONS_REJECTED';
export const LIST_REGIONS_FULFILLED = 'branch/LIST_REGIONS_FULFILLED';

export const UPDATE_BRANCH = 'branch/UPDATE_BRANCH';
export const UPDATE_BRANCH_PENDING = 'branch/UPDATE_BRANCH_PENDING';
export const UPDATE_BRANCH_FULFILLED = 'branch/UPDATE_BRANCH_FULFILLED';
export const UPDATE_BRANCH_REJECTED = 'branch/UPDATE_BRANCH_REJECTED';


export const saveBranch = (branch) => {
    const payload = createBranch(branch);
    return {
        type: CREATE_BRANCH,
        payload
    }
}

export const updateBranch = (branch) => {
    const payload = editBranch(branch);
    return {
        type: UPDATE_BRANCH,
        payload
    }
}

export const listBranches = (insurer) => {
    const payload = getBranches(insurer);
    return {
        type: LIST_BRANCHES,
        payload
    }
}

export const listRegions = (insurer) => {
    const payload = getRegions(insurer);
    return {
        type: LIST_REGIONS,
        payload
    }
}




// WEBPACK FOOTER //
// ./src/actions/branches.js